export function removeErrors() {
    const errors = document.querySelectorAll('.error-message');
    const errorBase = document.querySelectorAll('[data-error="base"]');
    if(errors) {
        errors.forEach(error => {
            error.innerHTML = '';
        });
    }

    if(errorBase) {
        errorBase.forEach(error => {
            error.remove('');
        })
    }
}
